import {create} from 'zustand';
import {FormStepEnum} from '../../types';
import {UseStepSendDocsStoreProps} from './types';

export const useStepSendDocsStore = create<UseStepSendDocsStoreProps>((set, get) => ({
	step: FormStepEnum.BENEFICIARY_DATA,
	setStep: step => set({step}),
	resetStep: () => set({step: FormStepEnum.BENEFICIARY_DATA}),
	nextStep: () => set({step: get().step + 1}),
	previousStep: () => set({step: get().step - 1}),
}));
